import React from 'react';
import JobPost from '../Posts/JobPost';
import { AnyAttachment } from '../NewsfeedModels';
import Image from './components/Image';
import Attachments from './Attachments';
import Provider from './components/Provider';
import Availability from './components/Availability';

interface AttachmentsProps {
    items: AnyAttachment[];
}

const attachmentMapping = {
    OngoingRequest: JobPost,
    Image: Image,
    Babysitter: Provider,
    AvailabilityNewsfeedPost: Availability,
};

export default function PostAttachments({ items = [] }: AttachmentsProps) {
    return <Attachments items={items} mapping={attachmentMapping} />;
}
